import React, { useContext, useState, useEffect } from 'react';
import { TreeSelect } from 'antd';
import 'antd/dist/antd.css';
import styled from 'styled-components'
import {regionOrder} from '../data/treeData';
import regionCountryList from '../data/regionsCountryList.json'
import { ChartContext } from '../context/ChartContext';
import CountUp from 'react-countup';
import _ from 'lodash'
import usePrevious from '../hooks/usePrevious';
import { fontWeightL, fontSizeS, fontWeightXS, fontSizeL, colorTeal, colorPurple, ColorGreyDark } from '../styles/sharedStyles';
import Loader from 'react-loader-spinner'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import uuidv1 from 'uuid/v1'

const uniqueCountryList = _.uniqBy(regionCountryList, "country")

const MainCointainer = styled.div`
    display: grid;
    grid-template-rows: 2fr 1fr;
    height: 100%;
    padding: 1rem;
`

const DropDownContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

const CounterContainer = styled(DropDownContainer)`
    flex-direction: column;

    justify-content: flex-end;
    font-size: ${fontSizeL};
    font-weight: ${fontWeightL};

    transtion: color .3s;
    color: ${props => props.color};

    p {
        font-size: ${fontSizeS};
        font-weight: ${fontWeightXS};
        color: ${ColorGreyDark};
        margin-bottom: 0rem !important;
    }
`

const { SHOW_PARENT } = TreeSelect;


const getTreeData = (list) => {
    const newRegionList = [ ...new Set( list.map(item => item.region) ) ]
   // const newCountryList = [ ...new Set( list.map(item => item.country) ) ]
    const orderedRegions = regionOrder.filter(el => newRegionList.includes(el)).map(el => newRegionList.find(d => d === el))

    const treeData = orderedRegions.map(region => {
        return {  title: region, value: region, key: uuidv1(), children: 
                _.uniqBy(list
                                .filter(country => country.region === region )
                                .map(el => {return {title: el.country, value: el.country, key: el.country === "Other" ? "Other" : uuidv1()}})
                                .sort((a,b) => a.title.localeCompare(b.title)), 'key')
                    }
    })
    return { treeData, newRegionList }
}

const MapFilters = () => {
    
    const { countryTotals, path, reset, mapFilterValues, setMapFilterValues, 
            showHidden, setFutureMapFilterValues, potentialCountryTotals } = useContext(ChartContext)
    const [ firstCount, setFirstCount ] = useState(true)
    //const selectableCountries = potentialCountryTotals.filter(el => el.total > 0).map(el => el.countryName)
    const filteredCountryList = _.flatten(potentialCountryTotals.filter(d => d.total > 0).map(el => uniqueCountryList.filter(d => d.country === el.countryName)))
    const {treeData, newRegionList} = getTreeData(filteredCountryList)
    const pathDecided = path !== 'both'
    const totalNumber = pathDecided && _.sumBy(countryTotals, d => d.total)
    const prevTotal = usePrevious(totalNumber)
    // const countryLength = newCountryList.length
    // const previousCountryLength = usePrevious(countryLength)
    const handleFilterChange = value => {
        setMapFilterValues(value)
        setFutureMapFilterValues(value)
    }

    useEffect(() => {
        setMapFilterValues(newRegionList)
        setFutureMapFilterValues(newRegionList)
    }, [path])
    // useEffect(() => {
    //     if(countryLength < previousCountryLength){
    //         const newMapFilterValues = mapFilterValues.filter(el => newCountryList.includes(el) || newRegionList.includes(el))
    //         setMapFilterValues([...newMapFilterValues])
    //         setFutureMapFilterValues([...newMapFilterValues])}
    // }, [countryLength])

    const tProps = {
        treeData,
        value: [...mapFilterValues],
        onChange: handleFilterChange,
        treeCheckable: true,
        showCheckedStrategy: SHOW_PARENT,
        searchPlaceholder: 'Please select regions or countries...',
        style: {
          width: '100%',
        },
    };


    return ( 
        <MainCointainer
            data-tut="country-filter"
        >
            { path !== 'both' &&
            <>
                <DropDownContainer>
                    {
                        showHidden ?
                            <TreeSelect
                                {...tProps}
                            />
                            :
                            <Loader
                                type="MutatingDots"
                                color={path === "hrds" ? colorTeal : colorPurple}
                                height={100}
                                width={100}
                            />
                    }
                </DropDownContainer>
                { reset &&
                    <CounterContainer
                        color={path === "hrds" ? colorTeal : colorPurple}
                    >
                        <CountUp
                            start={firstCount ? 0 : prevTotal}
                            end={totalNumber}
                            delay={firstCount ? 1 : 0}
                            duration={1}
                            onEnd= {() => setFirstCount(prev => prev && false)}
                        />
                        <p>
                        {path === "hrds" ? "Human Rights Defenders" : "Legal Experts"}
                        </p>
                    </CounterContainer>
                }
            </>
            }
        </MainCointainer>
     );
}
 
export default MapFilters;


